import type {HelpFile} from '../../types/help'
import {CertificationPolicyWizardTestIds} from '../../../testids/CertificationPolicyWizardTestIds'

export const certificationPolicyWizardHelp: HelpFile = {
    docPage: '/docs/governance/certification-policies',
    texts: {
        [CertificationPolicyWizardTestIds.certificationPolicyWizardPage]:
            'Create or edit a certification policy step by step: basics, scope, review settings, and launch.',
        [CertificationPolicyWizardTestIds.certificationPolicyWizardStepContainer]: null,
        [CertificationPolicyWizardTestIds.btnNextStep]: null,
        [CertificationPolicyWizardTestIds.btnPreviousStep]: null,
        [CertificationPolicyWizardTestIds.btnSaveAndReturn]:
            'Save the policy and return to its summary page without staging a campaign.',
        [CertificationPolicyWizardTestIds.wizardDefaultPolicyInfo]: null,
        [CertificationPolicyWizardTestIds.wizardForbidden]: null,
    },
}
